import classNames from 'classnames'
import { useTranslation } from 'next-i18next'
import { useState } from 'react'

// Domains

// Components
import { ProductProperties } from '@src/telemetry/getProductPropertiesForTracking'
import { TELEMETRY_EVENT_NAMES } from '@src/telemetry/telemetry-events.constants'
import { trackEvent } from '@src/telemetry/track'

import SizeChart from '../../sizeChart'
import MeasuringGuide from '../../sizeChart/components/measuringGuide/MeasuringGuide'
import Tabs, { Tab } from '../../tabs'
import { ProductSizeGuide } from '../SizeGuide.types'

// Styles
import styles from './sizeGuideOne.module.scss'

interface SizeGuideOneProps {
  wrapperClassName?: string
  productSizeGuides: ProductSizeGuide[]
  activeSizeGuideUnitIndex: number
  productProperties?: ProductProperties
}

enum TAB_STATES {
  SIZE_CHART = 'SIZE CHART',
  MEASURING_GUIDE = 'MEASURING GUIDE',
}

const SizeGuideOne = (props: SizeGuideOneProps) => {
  const { t } = useTranslation('common')
  const [activeTabId, setActiveTabId] = useState(TAB_STATES.SIZE_CHART)
  return (
    <div className={classNames(props.wrapperClassName, styles.sizeGuideOne)}>
      <Tabs
        activeTabId={activeTabId}
        onChange={activeId => {
          setActiveTabId(activeId as TAB_STATES)
          trackEvent(TELEMETRY_EVENT_NAMES.SIZE_CHART_TAB, {
            section_type: 'size_chart_tab',
            context: {
              size_chart_name: props.productSizeGuides[0]?.sizeChart?.title,
              size_chart_tab_value: activeId,
              productProperties: props.productProperties,
            },
          })
        }}
        className={styles.sizeGuideOne_tabsContainer}
        tabButtonWrapperClassname={styles.sizeGuideTabsContainer__tabButtonWrapper}
        activeTabHeaderClassName={styles.sizeGuideTabsContainer__tabHeader__active}
      >
        <Tab
          id={TAB_STATES.SIZE_CHART}
          title={t('size_chart')}
          headerClassName={styles.sizeGuideTabsContainer__tabHeader}
          panelClassName={styles.sizeGuideTabsContainer__tabContent}
        >
          <SizeChart
            productSizeGuides={props.productSizeGuides}
            activeSizeGuideUnitIndex={props.activeSizeGuideUnitIndex}
          />
        </Tab>

        <Tab
          id={TAB_STATES.MEASURING_GUIDE}
          title={t('measuring_guide')}
          headerClassName={styles.sizeGuideTabsContainer__tabHeader}
          panelClassName={styles.sizeGuideTabsContainer__tabContent}
        >
          {props.productSizeGuides[0]?.measuringGuide && (
            <MeasuringGuide measuringGuide={props.productSizeGuides[0].measuringGuide} />
          )}
        </Tab>
      </Tabs>
    </div>
  )
}

export default SizeGuideOne
